import React, { createContext, useCallback, useState } from 'react'

import { Modal } from 'antd'
import { useSelector } from 'react-redux'
import { isFunction, isArray } from 'lodash'

import { selectUser } from '../../reducers/UserReducer'
import { onError, onSuccess, resolvePromises } from '../../utils/apiHelper'
import { addSchoolSection } from '../../utils/api/schoolSection'
import { getFullAbbreviation, SchoolSection } from '../../utils/entities/schoolSection'
import BulkSchoolSectionForm from '../../Components/shared/SchoolSectionsDrawer/BulkSchoolSectionForm'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'

export const SchoolSectionModalContext = createContext()

const DEFAULT_FORM_HANDLER = { data: null, callback: null }

const SchoolSectionModal = ({ children, school }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [formHandler, setFormHandler] = useState(DEFAULT_FORM_HANDLER)

  const handleClose = useCallback(school => {
    setFormHandler(DEFAULT_FORM_HANDLER)

    if (isFunction(formHandler.callback)) {
      formHandler.callback(school)
    }
  }, [formHandler.callback])

  const handleSubmit = useCallback(schoolSections => {
    if (schoolSections.length > 0) {
      const promisesStack = []

      schoolSections.forEach((section, index) => {
        section = new SchoolSection(section)
        section.school = school

        promisesStack.push(
          addSchoolSection(user, section.toRequestBody()).then(response => {
            if (response?.data) {
              onSuccess(t('school_section.create.success.verbose', { name: getFullAbbreviation(section) }))
              return response.data
            } else {
              return null
            }
          }).catch(() => {
            onError(t('school_section.create.error.verbose', { name: getFullAbbreviation(section) }))

            return null
          })
        )
      })

      resolvePromises(promisesStack).then(sections => {
        handleClose(sections)
      })
    } else {
      handleClose([])
    }
  }, [t, user, formHandler.data, handleClose])

  return (
    <>
      <SchoolSectionModalContext.Provider value={{ formHandler, setFormHandler }}>
        {children}
      </SchoolSectionModalContext.Provider>
      <Modal
        visible={isArray(formHandler.data)}
        title={t('school_section_modal.title')}
        footer={null}
        onCancel={() => setFormHandler(DEFAULT_FORM_HANDLER)}
        bodyStyle={{ padding: '0px' }}
      >
        {isArray(formHandler.data) && (
          <div style={{ height: '60vh' }}>
            <BulkSchoolSectionForm
              useFooter
              validators
              onSubmit={handleSubmit}
              onCancel={() => setFormHandler(DEFAULT_FORM_HANDLER)}
            />
          </div>

        )}
      </Modal>
    </>
  )
}

export default SchoolSectionModal
